// components/Icons/MobileFilterIcon.js
const MobileFilterIcon = () => (
    <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="4.875" x2="36" y2="4.875" stroke="#4A4A51" strokeWidth="1.5"/>
      <circle cx="10.125" cy="4.5" r="3.75" fill="white" stroke="#4A4A51" strokeWidth="1.5"/>
      <line x1="36" y1="15.375" x2="0" y2="15.375" stroke="#4A4A51" strokeWidth="1.5"/>
      <circle cx="25.875" cy="15.75" r="3.75" transform="rotate(-180 25.875 15.75)" fill="white" stroke="#4A4A51" strokeWidth="1.5"/>
      <line x1="0" y1="27.375" x2="36" y2="27.375" stroke="#4A4A51" strokeWidth="1.5"/>
      <circle cx="10.125" cy="27" r="3.75" fill="white" stroke="#4A4A51" strokeWidth="1.5"/>
    </svg>
  );
  
  export default MobileFilterIcon;